// Allowed list:
//
// \s (white space)
// \w (word characters)
// \, (comma)
// \. (period)
// \* (asterisk)
// \- (hyphen)
// \+ (plus)
// \( (open parenthesis)
// \) (close parenthesis)
// \" (double quote)
// \' (single quote)
// \_ (underscore)
// \@ (at symbol)
//
export const sanitize = (str) => {
  let queryStr = str || "";
  queryStr = queryStr.replace(/[^\w\s\,\.\*\-\+\(\)\"\' _@]/g, "");
  return formatQuotations(queryStr);
}

function formatQuotations(str) {
  if ((str.match(/"/g) || []).length % 2 === 1) {
    str = str.replace(/"/, "");
  }

  if ((str.match(/'/g) || []).length % 2 === 1) {
    str = str.replace(/'/, "");
  }
  return str.trim();
}

/**
 * Highlights occurrences of term within item by wrapping them in <span class={highlightClass}> tags.
 * Note: Returns a string containing HTML (<span> tags) that use React syntax. When using with React, this output
 * will need to be handled appropriately (e.g., with dangerouslySetInnerHTML or by converting to React elements).
 *
 * @param {string} item - The text to search within
 * @param {string} term - The term to highlight
 * @param {string} highlightClass - the CSS class that performs the highlighting
 * @returns {string} HTML string with matching terms wrapped in <span class={highlightClass}> tags
 */
export const highlightTermInItem = (item, term, highlightClass) => {
  if (!term || !item) {
    return item;
  }

  // Escape special characters in the input value to prevent regex issues
  const escapedInput = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Create a case-insensitive regular expression
  const regex = new RegExp(`(${escapedInput})`, 'gi');

  return item.replace(regex, `<span class="${highlightClass}">$1</span>`);
};

// Example usage:
// highlightTermInItem("Hello World", "world", "highlight-class") => "Hello <span class="highlight-class">World</span>"
// highlightTermInItem("JavaScript and TypeScript and plain script", "script") => "Java<span class="highlight-class">Script</span> and Type<span className="highlight-class">Script</span> and plain <span className="highlight-class">script</span>"

